import {isFeatureEnabled} from '@github-ui/feature-flags'
import NewFeaturesCopilotIndex from './NewIndex'
import {LegacyFeaturesCopilotIndex} from './LegacyIndex'

export default function FeaturesCopilotIndex() {
  if (isFeatureEnabled('site_copilot_free')) return <NewFeaturesCopilotIndex />
  return <LegacyFeaturesCopilotIndex />
}

try{ FeaturesCopilotIndex.displayName ||= 'FeaturesCopilotIndex' } catch {}